module.exports = __webpack_public_path__ + "static/media/questioner-talk.bb31af1e.gif";